<div class="layout-topbar" style="gap:12px">
    <button #menubutton class="p-link layout-menu-button layout-topbar-button" style="margin-left:0" (click)="layoutService.onMenuToggle()"
        [attr.aria-label]="layoutService.state.rail ? 'Expandir menú' : 'Achicar menú'" [attr.aria-expanded]="!layoutService.state.rail">
        <i class="pi pi-bars"></i>
    </button>

    <button type="button" class="dh-search-trigger" (click)="openSearch()" aria-label="Búsqueda global (Ctrl + K)">
        <i class="pi pi-search" aria-hidden="true"></i>
        <span class="flex-1 white-space-nowrap overflow-hidden text-overflow-ellipsis">Buscar reserva, cliente, bar, código…</span>
        <span class="dh-kbd hidden md:inline">{{ shortcut }}</span>
    </button>

    <button #topbarmenubutton class="p-link layout-topbar-menu-button layout-topbar-button" (click)="layoutService.showProfileSidebar()" aria-label="Menú de usuario">
        <i class="pi pi-ellipsis-v"></i>
    </button>

    <div #topbarmenu class="layout-topbar-menu align-items-center gap-2" [ngClass]="{'layout-topbar-menu-mobile-active': layoutService.state.profileSidebarVisible}">
        <button type="button" class="dh-user" (click)="userMenu.toggle($event)" [attr.aria-label]="'Menú de ' + user.name">
            <span class="dh-avatar" aria-hidden="true">{{ initials }}</span>
            <span class="dh-user-name hidden lg:inline">{{ user.name }}</span>
            <i class="pi pi-chevron-down hidden lg:inline" aria-hidden="true"></i>
        </button>
        <p-menu #userMenu [model]="userItems" [popup]="true" appendTo="body"></p-menu>
    </div>
</div>
<app-search-dialog #search></app-search-dialog>
